import BaseRepository from '@/api/repositories/BaseRepository';

class VehicleModelRepository extends BaseRepository {
	get endpoint() {
		return 'api/vehiclemodel';
	}
}

export default new VehicleModelRepository();
